module.exports = __webpack_public_path__ + "img/banner-cloud.6a72875f.png";